import React from 'react'
import moment from 'moment'
import queryString from '../../utils/queryString'

export default (props) => {
  const {
    route_id,
    route_long_name,
    route_short_name,
    date,
    time,
    directionId,
    baseUrl,
    children,
    className
  } = props

  const lineUrlData = {
    route: JSON.stringify({
      route_id,
      route_long_name,
      route_short_name,
    }),
    date: date || moment().format('DD-MM-YYYY'),
    time: time || moment().format('HH:mm'),
    direction: !isNaN(directionId) ? directionId : 1
  }
  const lineUrl = `${baseUrl || '/'}${queryString.parseObject(lineUrlData)}`

  return (
    <a className={className} href={lineUrl}>
      {children}
    </a>
  )
}


// WEBPACK FOOTER //
// ./src/components/Dienstregeling/Link.js